import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { ASUHeader } from '@asu/component-header-footer/dist/asuHeaderFooter.es.js';
import desktopLogo from '../images/arizona-state-university-logo-vertical.png';
import mobileLogo from '../images/arizona-state-university-logo.png';
import serviceauth from '../auth/serviceauth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as faHeartSolid } from '@fortawesome/free-solid-svg-icons';

const HeaderStyle = createGlobalStyle`
  header {
    position: sticky;
 
    // this should not be necessary anymore
    // .content-container {
    //   font-size: 1rem;
    //   border: 0;
    //   margin: 0;
    //   height: fit-content;
    //   align-items: start;
    //   flex-direction: row;
    // }

   // link looks better with cursor: pointer;
    a {
      cursor: pointer;
    }
  }
`;

function Header(props) {
  return (
    <>
      <HeaderStyle />
      <ASUHeader
        logo={{
          alt: 'logo',
          src: desktopLogo,
          mobileSrc: mobileLogo,
        }}
        loggedIn={
          sessionStorage.getItem(serviceauth.SS_NAME) &&
          sessionStorage.getItem(serviceauth.SS_JWT_TOKEN)
        }
        userName={sessionStorage.getItem(serviceauth.SS_NAME)}
        logoutLink="/logout"
        loginLink={serviceauth.redirectToServiceauthUrl(true)}
        navTree={props.navTree}
        buttons={buttons(props)}
        title="Class Search"
        searchUrl="https://search.asu.edu/search"
      />
    </>
  );
}

const buttons = (props) => {
  // Add catalog parameter to favorites URL if catalog prop is true
  const favoritesUrl =
    props && props.catalog
      ? '/catalog/favorites?type=courses'
      : '/catalog/favorites';

  return [
    {
      href: favoritesUrl,
      text: (
        <>
          <FontAwesomeIcon icon={faHeartSolid} className="me-1" aria-hidden="true" />
          <span className="sr-only">View your saved favorite classes and courses</span>
          <span aria-hidden="true">My favorites</span>
        </>
      ),
      color: 'maroon',
      classes: 'custom-class',
    },
  ];
};

export default Header;
